import MgpGuarantyBar from '../../../elements/MgpGuarantyBar/MgpGuarantyBar';
import { accessJsonAttr, getPriceOfOffer, isMobile } from '../../../utils/utils';
import MgpFormSelect from '../../../elements/MgpFormSelect/MgpFormSelect';
import { useState } from 'react';
import { IGarantie, IOptionCotisation } from '../../../context/model';
import MgpButton from '../../../elements/MgpButton/MgpButton';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import { UseFormRegister } from 'react-hook-form';


type GuarantyCompareFormComponentProps = {
  handleSwitchPage: (pageCode: "INFO" | "INFO_TABLE" | "OFFER" | "COMPARE") => void;
  garanties: IGarantie[];
  offers: IOptionCotisation[];
  offerCode: string;
  errors: any;
  handleChooseOffer: (e: any, code: string) => void;
  register: UseFormRegister<any>
}


export default function REGuarantyCompareFormComponent({handleSwitchPage, garanties, offers, offerCode, errors, handleChooseOffer, register}: Readonly<GuarantyCompareFormComponentProps>) {

 

  const guarantyOptions = garanties.find(el => el.garantieBase)!.couvertures.map(example => {return example.couvertureTitre});

  const [option, setOption] = useState<string | null>(guarantyOptions[0]);

  const [hoveredElement, setHoveredElement] = useState<string>("");

 

  const onMousseIn = (element: string) => {
    setHoveredElement(element);
  }

  const onMousseOut = () => {
    setHoveredElement("");
  }

  const chartColor = () => {
    const hoveredStyle = {
      scale: 1.05
    }
    return (
      <div className='m-y-sm'>
        <div className='color-note'>
          <p className='color-box bg-fushia' style={hoveredElement === "adherent" ? hoveredStyle : {}}></p>
          <p>Reste à charge</p>
        </div>
        <div className='color-note'>
          <p className='color-box bg-bleu' style={hoveredElement === "mgp" ? hoveredStyle : {}}></p>
          <p>Remboursement MGP</p>
        </div>
        <div className='color-note'>
          <p className='color-box bg-bleu-60' style={hoveredElement === "secu" ? hoveredStyle : {}}></p>
          <p>Remboursement Sécurité sociale</p>
        </div>
      </div>
    )
  }

  const getCouverture = (garantie: IGarantie) => {
    let title = option;
    if (!option) {
      const exampleOption = guarantyOptions && guarantyOptions.length > 0 ? guarantyOptions[0] : '';
      title = exampleOption;
    }
    return garantie.couvertures.find(el => el.couvertureTitre === title);
  }

 

 if (garanties.length === 0) {
    return <MgpMessage type="danger" message='Les garanties non trouvées' hasCloseBtn={true}/>;
  }

  

 
  if (isMobile()) {
    return (           
      <form  style={{width: '100%'}}>
        <div className='guaranty-container grid-flex va-center'>
          <div className='form-row'>
            <div className='form-group'>
              <MgpFormSelect id='option' labelFontWeight='regular'
                  data={guarantyOptions?.map(el => {return {code: el, label: el}}) || []}    
                  register={register}
                  errors={errors}
                  label='Remboursement de '
                  onChange={(e) => setOption(e.target.value)}
                  defaultValue={option??''}
              />
                 
            </div>
          </div>
        
          <div className='mb-xl'>
            <div className='flex' style={{height: "300px", gap: "10px"}}>
              {
                garanties.map((garantie, i) => 
                <div  key={i+1}>
                  <MgpGuarantyBar handleOnMousseIn={onMousseIn} handleOnMousseOut={onMousseOut} title={garantie.titre} value1={getCouverture(garantie)?.exemplePartSecu??0} value2={getCouverture(garantie)?.exemplePartMgp??0} value3={getCouverture(garantie)?.exemplePartAdherent??0} />
                </div>)
              }
            </div>
          </div>

          <div className='form-row mt-md'>
            <div className='form-group mw-100'>
              <p className='text fz-md fw-bold'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleTitre}</p>
              <p className='text mb-sm'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleDescription}</p> 
            </div>
          </div>
         

          <div className='form-row'>
            <div className='form-group mw-100'>
            {chartColor()}
            </div>
          </div>
          
          <div className=''>
            {
              garanties.map((garantie, i) => { 
                  const offerCodeStyle = offerCode && (offerCode === garantie.code ?'btn-selected' : 'un-select' )
  
                return (
                <div className={`select-btn m-y-md shadow-noir ${offerCodeStyle}`} key={i+1}>
                  {garantie.garantieBase ? <p className='ta-center m-xs'>{garantie.titre}</p> : 
                    <div className='ta-center m-x-xs'>
                      <p>{garantie.titre}</p>
                      <p>{getPriceOfOffer(offers, garantie.code)}  / mois</p>
                    </div>}
                  {
                    offerCode === garantie.code ?
                    <MgpButton  type="button" text="" color='bleu' size="small" variant="inverse" icon="coche"/> :
                    <MgpButton  type="button" text="Choisir" color='bleu' size="small"  onClick={(e) => handleChooseOffer(e, garantie.code)}/>
                   
                  }
                </div>
                )})
            }

          </div>
        </div>
    
       
      </form>
  )
  }

    return (           
      <form  style={{width: '100%'}}>
        <div className='flex mb-lg'>
          {
            guarantyOptions?.map((el,i) => {
            return (
            <button        
              key={i+1} 
              className={`guaranty-option fw-medium option-button ${option === el ? "guaranty-option-selected" : ''}`} 
              onClick={(e) => { 
                e.preventDefault();
                setOption(el)
              }}>
                {el}
            </button>)
            })
          }
        </div>
        
        <div className='guaranty-container va-center'>

          <div className='left-section col-width-2'>
            <p className='text fz-md fw-bold'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleTitre}</p>
            <p className='text mb-lg'>{garanties[0]?.couvertures?.find(el => el.couvertureTitre === option)?.exempleDescription}</p> 
            
            { chartColor() }
          </div>
          
          <div className='main-section col-width-6 mb-lg'>
            <div className='flex va-center ta-center' style={{height: "300px", gap: "25px", flexWrap: 'nowrap'}}>
              {
                garanties.map((garantie, i) => 
                <div className='' key={i+1}>
                  <MgpGuarantyBar handleOnMousseIn={onMousseIn} handleOnMousseOut={onMousseOut} title={garantie.titre} value1={Number((getCouverture(garantie)?.exemplePartSecu??0).toFixed(2))} value2={getCouverture(garantie)?.exemplePartMgp??0} value3={getCouverture(garantie)?.exemplePartAdherent??0}  />
                </div>)
              }
            </div>
          </div>

          <div className='right-section col-width-4'>
            {
              garanties.map((garantie, i) =>  {
                const offerCodeStyle = offerCode && (offerCode === garantie.code ?'btn-selected' : 'un-select' )
                // !offerCode ? '' : offerCode === garantie.code ? 'btn-selected' : 'un-select'

               return ( 
               <div className={`select-btn m-y-md shadow-noir ${offerCodeStyle}`} key={i+1}>
                  <div className='ta-center m-x-xs'>
                    <p>{garantie.titre}</p>
                    <p>{getPriceOfOffer(offers, garantie.code)}  / mois</p>
                  </div>
                  {
                    offerCode === garantie.code ?
                    <MgpButton  type="button" text="Choisi" color='bleu' size="small" variant="inverse" icon="coche"/> :
                    <MgpButton  type="button" text="Choisir" color='bleu' size="small"  onClick={(e: any) => handleChooseOffer(e, garantie.code)}/>
                   
                  }
                 
                </div>)})
            }

          </div>
        </div>
         {garanties.length > 1 &&
                  <div className='m-y-sm pb-sm' style={garanties.length > 2 ? {textAlign:'center'} : {}}>
                      {errors && accessJsonAttr(errors, 'offerCode') && <p className="fushia m-y-md fw-medium fz-md">(*) Veuillez choisir une offre ci-dessus.</p>}
                      <button className='cta-blanc cta-small' onClick={() => handleSwitchPage("OFFER")}>Comparer les garanties</button>
                  </div>
                }
       
      </form>
  )
}
